export default "__VITE_ASSET__19e50055__"